// extracted by mini-css-extract-plugin
export default {"screen-reader-only":"ScreenReaderOnly_screen-reader-only__xFPKJ"};